var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "balance-reports" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c(
        "div",
        { staticClass: "chart-container" },
        [
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _c("ChartDoddleIcon"),
                  _vm._v(" "),
                  _c("h2", [_vm._v("Cüzdan Hareketleri")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("BalanceChart", { attrs: { filters: _vm.filters } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _c("ChartDoddleIcon"),
                  _vm._v(" "),
                  _c("h2", [_vm._v("Cüzdan Hareket Tipi")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("BalanceSpendChart", { attrs: { filters: _vm.filters } }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }